// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
import { Tag, TagColor } from '@teamnine/pcj-ui-v2'

const statusMap: Record<string, 'pending' | 'error' | 'warning' | 'success'> = {
  UNKNOWN: 'warning',
  SUCCESS: 'success',
  FAILURE: 'error',
  PENDING: 'pending',
  DESTROY_PENDING: 'pending',
  DESTROY_SUCCESS: 'success',
  DESTROY_FAILURE: 'error',
  NO_RECORDS: 'success',
  AWAITING_TENANT_CONFIGURATION: 'warning',
}

const statusColorMap: Record<
  'pending' | 'error' | 'warning' | 'success',
  TagColor
> = {
  pending: 'secondary',
  error: 'danger',
  warning: 'warning',
  success: 'success',
}

type StatusTagProps = {
  status?: string
}

export default function StatusTag({ status }: StatusTagProps) {
  const normalized = statusMap[status ?? ''] ?? ('warning' as const)
  const color = statusColorMap[normalized]

  const label = normalized.charAt(0).toUpperCase() + normalized.slice(1)

  return <Tag color={color}>{label}</Tag>
}
